const getUrlByFolderArray = folderArray => {
  const result = folderArray
    .map(obj => {
      return `${obj.name.replaceAll(/ /g, '-')}-${obj.uuid}`;
    })
    .join('/');

  return result;
};

export default getUrlByFolderArray;
